import { u2000IsValidEmail } from '../../u2000Core/tools/U2000EmailHelper';
import type { U2106ProfileFormRow } from '../U2106Service';

export type U2106ProfileFormValidationMessages = {
  requiredField: string;
  emailInvalid: string;
};

/**
 * Validation client Mon profil (BL-0440 courriels + champs obligatoires).
 * Fonction pure — testable sans rendu React.
 */
export function u2106CollectProfileFormErrors(
  row: U2106ProfileFormRow,
  hasEmployee: boolean,
  messages: U2106ProfileFormValidationMessages,
): Record<string, string> {
  const result: Record<string, string> = {};

  if (!row.userEmail?.trim()) {
    result.userEmail = messages.requiredField;
  } else if (!u2000IsValidEmail(row.userEmail)) {
    result.userEmail = messages.emailInvalid;
  }
  if (!row.userFirstName?.trim()) {
    result.userFirstName = messages.requiredField;
  }
  if (!row.userLastName?.trim()) {
    result.userLastName = messages.requiredField;
  }

  if (hasEmployee) {
    if (!row.firstName?.trim()) {
      result.firstName = messages.requiredField;
    }
    if (!row.lastName?.trim()) {
      result.lastName = messages.requiredField;
    }
    if (!row.addressLine1?.trim()) {
      result.addressLine1 = messages.requiredField;
    }
    if (!row.city?.trim()) {
      result.city = messages.requiredField;
    }
    if (!row.postalCode?.trim()) {
      result.postalCode = messages.requiredField;
    }
    if (row.email?.trim() && !u2000IsValidEmail(row.email)) {
      result.email = messages.emailInvalid;
    }
  }

  return result;
}
